module.exports = __webpack_public_path__ + "img/stat3.4c84d962.svg";